
import React, {useState,Fragment, useEffect} from "react";
import "./Modal.css";

const Modal =  (props) => {
    const [showModal,setShowModal]=useState(false);
     useEffect(()=>{
         if(!!props.show){
             setShowModal(true);          
         }
         else{
            setShowModal(false);
         }

     },[props.show]);
     useEffect(()=>{
        if(showModal){
          setTimeout( ()=>{
           let modalId =  document.getElementById("modal-id").offsetTop;
           window.scrollTo(0,modalId);
          },200);
        }
    },[showModal]);
    const CloseModal = (e)=>{
      
        setShowModal(false);
        props.onClose();
    };
    function CreateDicLanguages(){
        var dic ={};
        
        dic.he={};
        dic.en={};
        dic.he["MODCloseBtn"]="סגירה";
        dic.he["MODSuccessText"]=", קיבלנו את פנייתך, היא תועבר לגורם המטפל";
        dic.he["MODErrorText1"]="אירעה שגיאת מערכת";
        dic.he["MODErrorText2"]="אנא נסה שוב במועד מאוחר יותר";
      
        dic.en["MODCloseBtn"]="Close";
        dic.en["MODSuccessText"]=", We recieved your request.";
        dic.en["MODErrorText1"]="Error occurred";
        dic.en["MODErrorText2"]="Please try later";
        
      
          return dic.en;
      
    
      }
    return(<div>

    {
    
    showModal && <div>

    <div className=" show"  role="dialog" aria-hidden="true" id="modmodal" aria-modal="true">
      <div role="document" className="modal-dialog modal-dialog-centered m-auto" id="modal-id">
            <div  className="modal-content">
                <div className="modal-body  col-12 ">
                <div className={'col-12 col-md-12'}>
                {props.isSucc ? 
                                <div className={'col-12'}> 
                                     <div><img src='/_layouts/15/Images/Sites/Mashan/dialog-icon.png'/></div>
                                     <div>{props.data}{CreateDicLanguages().MODSuccessText}</div>    
                                </div> 
                             : ( <div  className={'col-12 col-md-12'}> <div>{CreateDicLanguages().MODErrorText1}</div><div>{CreateDicLanguages().MODErrorText2}</div> </div>)
                }
                   </div>  
                   </div>
                   <div className='col-12 modal-footer'>
            <button onClick={CloseModal} className="submitButModal col-6 col-md-6" >{CreateDicLanguages().MODCloseBtn}</button> 
            </div>
               
            </div>        
        </div>        
    </div>
        <div className="modal fade show" aria-hidden="true" aria-modal="true"></div>
    </div>}
 
   </div>
   )
            }

    
  
    export default Modal;